import { selectType } from './utils';
import addModal from './addModal.vue';
import { tagList, getTagsClass } from './request.js';
export default {
  components: {
    addModal
  },
  data() {
    return {
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80,
        align: 'center'
      }, {
        slots: {
          title: '标签名称'
        },
        dataIndex: 'label',
        key: 'label',
        align: 'center'
      },
      // {
      //   title: '分类',
      //   dataIndex: 'className',
      //   key: 'className',
      //   align: 'center'
      // },
      // {
      //   title: '创建类型',
      //   dataIndex: 'typeName',
      //   key: 'typeName',
      //   align: 'center'
      // },
      // {
      //   title: '创建人',
      //   dataIndex: 'userName',
      //   key: 'userName',
      //   align: 'center',
      //   ellipsis: true,
      //   customRender: (text, record) => (
      //     <a-tooltip placement="topLeft" title={record.userName}>
      //       {record.userName}
      //     </a-tooltip>
      //   )
      // },
      {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: 'createAt',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'operation',
        key: 'operation',
        align: 'center',
        width: 200,
        scopedSlots: {
          customRender: 'operation'
        }
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      selectType,
      form: {
        tagsName: ''
      },
      tableData: [],
      addVisible: false,
      isEdit: false,
      classList: []
    };
  },
  created() {
    this.onSearch();
    this.getSelectList();
  },
  methods: {
    onSearch() {
      this.pagination.current = 1;
      this.getListData();
    },
    async getListData() {
      const {
        items,
        totalNum
      } = await tagList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.tableData = items;
      this.pagination.total = totalNum;
    },
    async getSelectList() {
      this.classList = await getTagsClass({
        page: 1
      });
    },
    tablePageChange(val) {
      this.pagination = val;
      this.getListData();
    },
    openAddModal(value) {
      this.isEdit = value;
      this.addVisible = true;
    }
  }
};